import React from 'react';
import { ReactComponent as Icon } from 'assets/icons/brand-status.svg';
import { Dropdown, Input } from '@cokitchen/cokitchen-components';
import './style.scss';
import { ChromePicker } from 'react-color';

type Props = {
  comingSoon: boolean;
  popup: boolean;
  color: string;
  setNew: (color: boolean) => void;
  setPopup: (popup: boolean) => void;
  setColor: (color: string) => void;
  comment: string;
  setComment: (comment: string) => void;
  className?: string;
  setComingSoon: (comingSoon: boolean) => void;
  isNew: boolean;
  disabled?: boolean;
  isTop: boolean;
  setIsTop: (value: boolean) => void;
};

const BrandStatus = ({
  popup,
  color,
  setColor,
  setNew,
  setPopup,
  isNew,
  comment,
  setComment,
  comingSoon,
  setComingSoon,
  className,
  disabled,
  isTop,
  setIsTop
}: Props) => (
  <div className={`w-full p-[20px] bg-[#F9F6F6] rounded-md ${className}`}>
    <div className='flex gap-2 mb-8'>
      <Icon className='text-[#1D0105]' />
      <p className='text-sm text-[#1D0105] font-medium'>Select the status of this brand</p>
    </div>
    <div className='flex gap-10 flex-wrap'>
      <div className='flex gap-[8px] items-center'>
        <Input
          type='checkbox'
          name='new'
          checked={isNew}
          onChange={(e) => setNew(e.target.checked)}
          label='New'
          disabled={disabled}
        />
      </div>
      <div className='flex gap-[8px] items-center'>
        <Input
          type='checkbox'
          name='top'
          checked={isTop}
          onChange={(e) => setIsTop(e.target.checked)}
          label='Top'
          disabled={disabled}
        />
      </div>
      <div className='flex gap-[8px] items-center'>
        <Input
          type='checkbox'
          name='popup'
          checked={popup}
          onChange={(e) => setPopup(e.target.checked)}
          label='Pop up brand'
          disabled={disabled}
        />
      </div>
      <div className='flex gap-[8px] items-center'>
        <Input
          type='checkbox'
          name='comingSoon'
          checked={comingSoon}
          onChange={(e) => setComingSoon(e.target.checked)}
          label='Coming soon'
          disabled={disabled}
        />
      </div>
    </div>

    {comingSoon && (
      <div className='w-full mt-6'>
        <Input
          type='text'
          placeholder='Enter coming soon  text'
          className='w-full mt-4'
          inputClass='px-[20px] py-[14px]'
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          disabled={disabled}
        />
      </div>
    )}
    {popup && (
      <div className='w-full mt-4 relative'>
        <Dropdown
          disabled={disabled}
          content={
            <div className='flex justify-between items-center h-[52px] border border-gray-6 rounded-lg pl-5 pr-1 bg-white'>
              <span>{color || 'Pop up color code (Hex)'}</span>
              {color && (
                <div
                  className='w-[60px] h-[40px] rounded shadow shadow-gray-3'
                  style={{ backgroundColor: color }}
                />
              )}
            </div>
          }>
          <ChromePicker color={color || ''} onChangeComplete={(c) => setColor(c?.hex || '')} />
        </Dropdown>
      </div>
    )}
  </div>
);

export default BrandStatus;
